import React, { useMemo } from "react";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import { sidingNameUpdateForWallTexture } from "../../../../redux/reducers/utils";
const ColorItem = ({ color, isActive, onClick, isPremium = false, baseUrl = process.env.REACT_APP_BASE_URL || "", index = 0, wainsCoatComponent }) => {
	const imageSrc = useMemo(() => {
		if (!color?.image_name) return "";
		try {
			if (wainsCoatComponent) {
				let img_src = "";
				if (color?.image_name) {
					try {
						if (color.image_name) {
							img_src = require(`../../../../assets/images/color-image/${color.image_name}`);
						}
						if (img_src == "") {
							img_src = require(`../../../../assets/images/color-image/${sidingNameUpdateForWallTexture(color.name)}.svg`);
						}
						return img_src;
					} catch (err) {
						console.log("wainscot image not found");
					}
				}
			}
			else{
				return require(`../../../../assets/images/color-image/${color.image_name}`);
			}
		} catch (err) {
			console.warn(`Color image not found: ${color.image_name}`);
			return "";
		}
	}, [color?.image_name]);
	const hasImage = !!imageSrc;
	const backendValue = color?.hex_value?.replace("#", "0x");
	return (
		<div className="color-item">
			<label
				className={`color-switch ${hasImage ? "with-img" : ""} ${isActive ? "active" : ""} ${isPremium ? "premium-color" : ""}`}
				style={
					hasImage
						? {
								backgroundImage: `url(${baseUrl}${imageSrc})`,
								backgroundSize: "cover",
								backgroundPosition: "center"
							}
						: {
								background: color?.hex_value || "#ffffff",
								borderColor: color?.hex_value || "#ffffff"
							}
				}
				onClick={onClick}
				title={color?.name}
				role="button"
				tabIndex={0}
				onKeyPress={(e) => {
					if (e.key === "Enter" || e.key === " ") {
						onClick();
					}
				}}
			>
				<input type="radio" name="color-option" value={backendValue} id={`color-${index}`} aria-label={`${color?.name}${isPremium ? " - Premium" : ""}`} readOnly />
				{isPremium && (
					<OverlayTrigger
						placement="bottom"
						trigger="hover"
						overlay={
							<Popover className="popover-default">
								<Popover.Content>Premium Color</Popover.Content>
							</Popover>
						}
					>
						<i className="color-info">$</i>
					</OverlayTrigger>
				)}
			</label>
			<span className="color-switch-name">{color?.name}</span>
		</div>
	);
};

export default React.memo(ColorItem);
